function liveUpdate(token) {
  const HOST = location.origin.replace(/^http/, 'ws');
  const ws = new WebSocket(HOST);
  
  //Tells socket server to add client when connection is established
  ws.onopen = () => {
    // console.log('websocket connection opened');
    const msg = {
      action: 'addClient',
      payload: { token },
    };
    ws.send(JSON.stringify(msg));
  };
  //Reloads the page whenever app webhook hears an update (to load updated order)
  ws.onmessage = msg => {
    // console.log('websocket heard message from server');
    const data = JSON.parse(msg.data);
    if (data.action === 'update') {
      location.reload();
    }
  }

  // ws.onerror = error => {
  //   console.log('a websocket error occurred:', error);
  // }
}

module.exports = liveUpdate;


// WEBPACK FOOTER //
// ./public/src/liveUpdate.js